import {isFilled} from '@prismicio/client'
import cn from 'classnames'

type BioSectionProps = {
  drawer_bio_title?: string | null
  bio_info?: Array<{name: string | null; value: string | null}>
}

export const BioSection = ({drawer_bio_title, bio_info}: BioSectionProps) => {
  const hasBioTitle = isFilled.keyText(drawer_bio_title)
  const hasBioInfo = bio_info && bio_info.length > 0

  if (!hasBioTitle && !hasBioInfo) {
    return null
  }

  return (
    <div className="flex flex-col gap-2.5">
      {hasBioTitle && (
        <>
          <div className="h-px w-full border-b border-dashed border-moss-black" />
          <p className="text-left text-[12px] font-semibold uppercase tracking-[0.72px] text-moss-black">
            {drawer_bio_title}
          </p>
          <div className="h-px w-full border-b border-dashed border-moss-grey-400" />
        </>
      )}

      {hasBioInfo && (
        <>
          <div className="flex flex-col gap-2.5 sm:flex-row sm:gap-5">
            {bio_info.map((item, index) => (
              <div
                key={index}
                className={cn('flex w-full items-center sm:flex-1', {
                  'sm:p-0 sm:border-none border-b border-dashed border-moss-grey-400 pb-[10px]':
                    index < bio_info.length - 1,
                })}
              >
                <div className="flex flex-1 items-start justify-between text-[12px] uppercase leading-normal tracking-[0.72px]">
                  <div className="flex flex-col justify-center font-normal text-moss-black sm:font-semibold sm:text-moss-grey-400">
                    {item.name}
                  </div>
                  <div className="flex flex-1 flex-col justify-center whitespace-nowrap text-right font-semibold text-moss-black">
                    {item.value}
                  </div>
                </div>
                {index < bio_info.length - 1 && (
                  <>
                    <div className="hidden h-full w-px self-stretch border-l border-dashed border-moss-grey-400 sm:ml-5 sm:block" />
                  </>
                )}
              </div>
            ))}
          </div>
          <div className="h-px w-full border-b border-dashed border-moss-grey-400" />
        </>
      )}
    </div>
  )
}
